export const HEADERS = [
    'RFQ No.',
    'RFQ Type',
    'Leg Type',
    'Provider Type',
    'Contarct Start Date',
    'Contract End Date',
    'Source',
    'Destination',
    'Movement Type',
    'Vehicle Type',
    'Vehicle Body / Container Type',
    'No. Of Vehicles',
    'Pricing Basis',
    'TAT',
    'QBR',
    'Budget',
    'Provider'
];

export const VIEW_GENERATED_HEADERS = [
    'Contract No.',
    'RFQ No.',
    'RFQ Type',
    'Leg Type',
    'Provider Type',
    'Contarct Start Date',
    'Contract End Date',
    'Source',
    'Destination',
    'Movement Type',
    'Vehicle Type',
    'Vehicle Body / Container Type',
    'No. Of Vehicles',
    'Pricing Basis',
    'TAT',
    'QBR',
    'Budget',
    'Provider'
];

export const CONTRACT_DATA = [
    {
        rfqNumber: 'RFQ001',
        rfqType: 'Multi Modal',
        legType: 'Door To Yard',
        legName: 'Transportation',
        containerType: 'BCN',
        containerBody: 'BCN',
        source: 'Mundra',
        destination: 'Dhrub',
        tat: '2 Days',
        qbr: '260',
        budget: '260',
        cp1: 'IWARE SUPPLYCHAIN SERVICES PVT LTD',
        cp1ContractStartDate: '14 Oct 2020',
        cp1ContractEndDate: '30 Dec 2020',
        cp2: 'XYZ Supply Chain services ',
        cp2ContractStartDate: '14 Oct 2020',
        cp2ContractEndDate: '30 Dec 2020',
    },
    {
        rfqNumber: 'RFQ002',
        rfqType: 'Multi Modal',
        legType: 'Door To Yard',
        legName: 'Handling at Origin',
        containerType: 'BCN',
        containerBody: 'BCN',
        source: 'Mundra',
        destination: 'Dhrub',
        tat: '2 Days',
        qbr: '290',
        budget: '290',
        cp1: 'IWARE SUPPLYCHAIN SERVICES PVT LTD',
        cp1ContractStartDate: '14 Oct 2020',
        cp1ContractEndDate: '30 Dec 2020',
        cp2: 'XYZ Supply Chain services ',
        cp2ContractStartDate: '14 Oct 2020',
        cp2ContractEndDate: '30 Dec 2020',
    },
    {
        rfqNumber: 'RFQ003',
        rfqType: 'Multi Modal',
        legType: 'Door To  Yard',
        legName: 'First mile Port Charges',
        containerType: 'BCN',
        containerBody: 'BCN',
        source: 'Mundra',
        destination: 'Dhrub',
        tat: '2 Days',
        qbr: '80',
        budget: '80',
        cp1: 'ADANI PORTS AND SEZ LTD',
        cp1ContractStartDate: '14 Oct 2020',
        cp1ContractEndDate: '30 Dec 2020',
        cp2: 'ADANI PORTS AND SEZ LTD',
        cp2ContractStartDate: '14 Oct 2020',
        cp2ContractEndDate: '30 Dec 2020',
    },
    {
        rfqNumber: 'RFQ004',
        rfqType: 'Multi Modal',
        legType: 'Full rake',
        legName: 'Insurance Charges',
        containerType: 'BCN',
        containerBody: 'BCN',
        source: 'Mundra',
        destination: 'Dhrub',
        tat: '2 Days',
        qbr: '150',
        budget: '150',
        cp1: 'Insurance Charges',
        cp1ContractStartDate: '14 Oct 2020',
        cp1ContractEndDate: '30 Dec 2020',
        cp2: 'Insurance Charges',
        cp2ContractStartDate: '14 Oct 2020',
        cp2ContractEndDate: '30 Dec 2020',
    },
    {
        rfqNumber: 'RFQ005',
        rfqType: 'Multi Modal',
        legType: 'Port To Port',
        legName: 'Railway cost inculding Insurance and Port charges',
        containerType: 'BCN',
        containerBody: 'BCN',
        source: 'Dhurb - Mundra',
        destination: 'Amoshi',
        tat: '2 Days',
        qbr: '1377',
        budget: '1147',
        cp1: 'IWARE SUPPLYCHAIN SERVICES PVT LTD',
        cp1ContractStartDate: '14 Oct 2020',
        cp1ContractEndDate: '30 Dec 2020',
        cp2: 'ABC SUPPLYCHAIN SERVICES PVT LTD',
        cp2ContractStartDate: '14 Oct 2020',
        cp2ContractEndDate: '30 Dec 2020',
    },
    {
        rfqNumber: 'RFQ006',
        rfqType: 'Multi Modal',
        legType: 'Port To Door',
        legName: 'Handling at destination',
        containerType: 'BCN',
        containerBody: 'BCN',
        source: 'Amoshi Yard',
        destination: 'Amoshi Yard',
        tat: '2 Days',
        qbr: '370',
        budget: '370',
        cp1: 'IWARE SUPPLYCHAIN SERVICES PVT LTD',
        cp1ContractStartDate: '14 Oct 2020',
        cp1ContractEndDate: '30 Dec 2020',
        cp2: 'XYZ Supply Chain services ',
        cp2ContractStartDate: '14 Oct 2020',
        cp2ContractEndDate: '30 Dec 2020',
    },
    {
        rfqNumber: 'RFQ007',
        rfqType: 'Single Mode',
        legType: 'Port To Door',
        legName: 'Last mile',
        containerType: 'BCN',
        containerBody: 'BCN',
        source: 'Amoshi Yard',
        destination: 'ALAMBAGH',
        tat: '2 Days',
        qbr: '290',
        budget: '290',
        cp1: 'IWARE SUPPLYCHAIN SERVICES PVT LTD',
        cp1ContractStartDate: '14 Oct 2020',
        cp1ContractEndDate: '30 Dec 2020',
        cp2: 'XYZ Supply Chain services ',
        cp2ContractStartDate: '14 Oct 2020',
        cp2ContractEndDate: '30 Dec 2020',
    },
    {
        rfqNumber: 'RFQ008',
        rfqType: 'Single Mode',
        legType: 'Port To Door',
        legName: 'Last mile',
        containerType: 'BCN',
        containerBody: 'BCN',
        source: 'Amoshi Yard',
        destination: 'ALLAHABAD',
        tat: '2 Days',
        qbr: '800',
        budget: '800',
        cp1: 'IWARE SUPPLYCHAIN SERVICES PVT LTD',
        cp1ContractStartDate: '14 Oct 2020',
        cp1ContractEndDate: '30 Dec 2020',
        cp2: 'XYZ Supply Chain services ',
        cp2ContractStartDate: '14 Oct 2020',
        cp2ContractEndDate: '30 Dec 2020',
    },
    {
        rfqNumber: 'RFQ009',
        rfqType: 'Single Mode',
        legType: 'Port To Door',
        legName: 'Last mile',
        containerType: 'BCN',
        containerBody: 'BCN',
        source: 'Amoshi Yard',
        destination: 'ALLAHAGANJ',
        tat: '2 Days',
        qbr: '750',
        budget: '750',
        cp1: 'IWARE SUPPLYCHAIN SERVICES PVT LTD',
        cp1ContractStartDate: '14 Oct 2020',
        cp1ContractEndDate: '30 Dec 2020',
        cp2: 'XYZ Supply Chain services ',
        cp2ContractStartDate: '14 Oct 2020',
        cp2ContractEndDate: '30 Dec 2020',
    },
    {
        rfqNumber: 'RFQ010',
        rfqType: 'Single Mode',
        legType: 'Port To Door',
        legName: 'Last mile',
        containerType: 'BCN',
        containerBody: 'BCN',
        source: 'Amoshi Yard',
        destination: 'AMETHI',
        tat: '2 Days',
        qbr: '630',
        budget: '630',
        cp1: 'IWARE SUPPLYCHAIN SERVICES PVT LTD',
        cp1ContractStartDate: '14 Oct 2020',
        cp1ContractEndDate: '30 Dec 2020',
        cp2: 'XYZ Supply Chain services ',
        cp2ContractStartDate: '14 Oct 2020',
        cp2ContractEndDate: '30 Dec 2020',
    },
    {
        rfqNumber: 'RFQ011',
        rfqType: 'Single Mode',
        legType: 'Port To Door',
        legName: 'Last mile',
        containerType: 'BCN',
        containerBody: 'BCN',
        source: 'Amoshi Yard',
        destination: 'AMINABAD',
        tat: '2 Days',
        qbr: '290',
        budget: '290',
        cp1: 'IWARE SUPPLYCHAIN SERVICES PVT LTD',
        cp1ContractStartDate: '14 Oct 2020',
        cp1ContractEndDate: '30 Dec 2020',
        cp2: 'XYZ Supply Chain services ',
        cp2ContractStartDate: '14 Oct 2020',
        cp2ContractEndDate: '30 Dec 2020',
    },
    {
        rfqNumber: 'RFQ012',
        rfqType: 'Single Mode',
        legType: 'Port To Door',
        legName: 'Last mile',
        containerType: 'BCN',
        containerBody: 'BCN',
        source: 'Amoshi Yard',
        destination: 'ANAND NAGAR',
        tat: '2 Days',
        qbr: '290',
        budget: '290',
        cp1: 'IWARE SUPPLYCHAIN SERVICES PVT LTD',
        cp1ContractStartDate: '14 Oct 2020',
        cp1ContractEndDate: '30 Dec 2020',
        cp2: 'XYZ Supply Chain services ',
        cp2ContractStartDate: '14 Oct 2020',
        cp2ContractEndDate: '30 Dec 2020',
    },
]